module.exports = __webpack_public_path__ + "static/media/vail-4.e915387a.jpg";